import { Fragment, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { activeAnnouncements } from '../api/announcements';

// Tốc độ cuộn (pixel/giây) theo mức người dùng chọn.
const SPEEDS = [
  { key: 'slow', label: 'Chậm', pps: 60 },
  { key: 'normal', label: 'Vừa', pps: 120 },
  { key: 'fast', label: 'Nhanh', pps: 210 },
];

// Dòng chạy thông báo nội bộ — lấy các thông báo đang chạy (lọc theo phòng ban của người xem).
// onOpen: mở màn Quản lý thông báo khi click vào dòng chạy.
export default function AnnouncementBar({ onOpen }) {
  const [messages, setMessages] = useState([]);
  const [speedKey, setSpeedKey] = useState(() => localStorage.getItem('ft_marquee_speed') || 'normal');
  const [duration, setDuration] = useState(20);
  const spanRef = useRef(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      activeAnnouncements()
        // Dòng chạy chỉ hiển thị TIÊU ĐỀ (fallback nội dung nếu không có tiêu đề).
        .then((list) => alive && setMessages(list.map((a) => a.title || a.content)))
        .catch(() => {});
    load();
    const t = setInterval(load, 120000); // làm mới mỗi 2 phút để bắt thông báo mới/hết hạn
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  const pps = (SPEEDS.find((s) => s.key === speedKey) || SPEEDS[1]).pps;

  // Tính thời lượng animation = quãng đường (rộng 1 bản nội dung) / tốc độ -> tốc độ cuộn ổn định.
  useLayoutEffect(() => {
    const w = spanRef.current?.offsetWidth || 0;
    setDuration(Math.max(6, w / pps));
  }, [messages, pps]);

  // 1 bản nội dung: mỗi tiêu đề + icon ngăn cách rõ ràng.
  const group = (measureRef) => (
    <span className="marquee__group" ref={measureRef}>
      {messages.map((m, i) => (
        <Fragment key={i}>
          <span className="marquee__item">{m}</span>
          <i className="ti ti-diamond-filled marquee__sep" aria-hidden="true"></i>
        </Fragment>
      ))}
    </span>
  );

  const cycleSpeed = (e) => {
    e.stopPropagation();
    const idx = SPEEDS.findIndex((s) => s.key === speedKey);
    const next = SPEEDS[(idx + 1) % SPEEDS.length].key;
    setSpeedKey(next);
    localStorage.setItem('ft_marquee_speed', next);
  };

  if (!messages.length) return null;
  return (
    <div
      className="marquee marquee--link"
      role="button"
      tabIndex={0}
      title="Xem tất cả thông báo nội bộ"
      aria-label="Thông báo nội bộ — bấm để xem chi tiết"
      onClick={onOpen}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onOpen?.()}
    >
      <i className="ti ti-speakerphone marquee__ico" aria-hidden="true"></i>
      <div className="marquee__wrap">
        <div className="marquee__track" style={{ animationDuration: `${duration}s` }}>
          {group(spanRef)}
          {group()}
        </div>
      </div>
      <button className="marquee__speed" onClick={cycleSpeed} title="Đổi tốc độ chạy">
        {(SPEEDS.find((s) => s.key === speedKey) || SPEEDS[1]).label}
      </button>
    </div>
  );
}
